export default __webpack_public_path__ + "static/media/playSFX.3c5c2b32.mp3";